export default {
  apiVersion: 2,
  development: {
    accessToken: '9d402f50fefe29822081931d22cb7f5a',
    url: 'http://pitan.dev.moya.is/_/moya/pilot/api',
  },
  production: {
    accessToken: '9d402f50fefe29822081931d22cb7f5a',
    url: 'https://www.pitan.is/_/moya/pilot/api',
  },
};
